<template>
  <div class="flex flex-col flex-grow">
    <svg-loading></svg-loading>
  </div>
</template>

<script>
import SvgLoading from "@/components/Svg/SvgLoading";

export default {
  components: { SvgLoading },
};
</script>
